import { NgModule, Injector, LOCALE_ID, ErrorHandler } from '@angular/core';
import { registerLocaleData } from '@angular/common';
import { BrowserModule } from '@angular/platform-browser';
import { FormsModule } from '@angular/forms';
import { HttpModule } from '@angular/http';
import { MaterialModule, MdNativeDateModule, DateAdapter, MD_DATE_FORMATS, MdSelectModule } from '@angular/material';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { SimpleNotificationsModule, NotificationsService } from 'angular2-notifications';
import { Ng2DeviceDetectorModule } from 'ng2-device-detector';
import { TextMaskModule } from 'angular2-text-mask';

import { AppComponent } from './app.component';
import { LayoutComponent } from './layout/layout.component';
import { AppHeaderComponent } from './layout/header/header.component';
import { AppSidenavComponent } from './layout/sidenav/sidenav.component';
import { AppSidenavMenuComponent } from './layout/sidenav/sidenav-menu/sidenav-menu.component';
import { AppFooterComponent } from './layout/footer/footer.component';
import { ToggleOffcanvasNavDirective } from './layout/sidenav/toggle-offcanvas-nav.directive';
import { AutoCloseMobileNavDirective } from './layout/sidenav/auto-close-mobile-nav.directive';
import { AccordionNavDirective } from './layout/sidenav/sidenav-menu/accordion-nav.directive';
import { AppendSubmenuIconDirective } from './layout/sidenav/sidenav-menu/append-submenu-icon.directive';
import { HighlightActiveItemsDirective } from './layout/sidenav/sidenav-menu/highlight-active-items.directive';

import { AuthModule } from './auth/auth.module';
import { SharedModule } from './shared/shared.module';
import { AppRoutingModule } from './app-routing.module';
import { ComponentsModule } from './components/components.module';
import { ClipboardModule } from 'ngx-clipboard';

import { AuthGuard, CanActivateClienteBloqueado, CanActivateUsuario } from './auth/auth.guard';
import { GlobalErrorHandler } from './handlers/global.error.handler';

import { AccordionModule } from 'ngx-accordion';

import { DataTableModule, GalleriaModule, DataScrollerModule, FileUploadModule, DialogModule, ContextMenuModule, MenuModule } from 'primeng/primeng';

import { MY_DATE_FORMATS } from "./locale-adapters/MY_DATE_FORMATS";
import { MyDateAdapter } from "./locale-adapters/MyDateAdapter";
import { TranslateModule, TranslateLoader } from '@ngx-translate/core';
import { TranslateHttpLoader } from '@ngx-translate/http-loader';
import { HttpClientModule, HttpClient as HttpClient2 } from '@angular/common/http';
import localePTBR from '@angular/common/locales/pt';

import { HttpClientbase } from './services/httpclientBase';
import { AuthenticationService, LoadingService, NotificacaoService, createTranslateLoader } from './services/index';
import { DevedorService } from './services/index';
import { AcordoService } from './services/index';
import { TelefoneService } from './services/index';
import { EnderecoService } from './services/index';
import { EmailService } from './services/index';
import { RouterService } from './services/index';
import { LogSistemaService } from './services/index';
import { LayoutRoutingModule } from './layout/layout-routing.module';
import { PagamentoService } from './services/index';
import { CpfPipe } from './shared/pipes/cpf-mask.pipe';
import { LogWizardService } from './services/logWizard.service';
import { BoletoService } from './services/index';
import { CpfCnpjPipe } from './shared/pipes/cpfCnpj.pipe';

registerLocaleData(localePTBR);

@NgModule({
    imports: [
        BrowserAnimationsModule,
        MaterialModule,
        MdNativeDateModule,
        BrowserModule,
        FormsModule,
        HttpModule,
        AuthModule,
        AppRoutingModule,
        LayoutRoutingModule,
        SharedModule,
        DataTableModule,
        DataScrollerModule,
        FileUploadModule,
        DialogModule,
        ContextMenuModule,
        MenuModule,
        AccordionModule,
        ClipboardModule,
        GalleriaModule,
        HttpClientModule,
        ComponentsModule,        
        TextMaskModule,        
        SimpleNotificationsModule.forRoot(),
        Ng2DeviceDetectorModule.forRoot(),
        TranslateModule.forRoot({
            loader: {
                provide: TranslateLoader,
                useFactory: (createTranslateLoader),
                deps: [HttpClient2]
            }
        })
    ],
    declarations: [
        AppComponent,
        LayoutComponent,
        AppHeaderComponent,
        AppSidenavComponent,
        AppSidenavMenuComponent,
        AppFooterComponent,
        AppSidenavComponent,
        ToggleOffcanvasNavDirective,
        AutoCloseMobileNavDirective,
        AppSidenavMenuComponent,
        AccordionNavDirective,
        AppendSubmenuIconDirective,
        HighlightActiveItemsDirective        
    ],
    entryComponents: [],
    providers: [
        AuthGuard,
        CanActivateUsuario,
        CanActivateClienteBloqueado,
        LoadingService,
        DevedorService,
        AcordoService,
        TelefoneService,
        EnderecoService, 
        EmailService, 
        PagamentoService,
        LogSistemaService, 
        RouterService,         
        NotificationsService,
        NotificacaoService,
        AuthenticationService,
        HttpClientbase,
        LogWizardService,
        BoletoService,
        CpfCnpjPipe,
        { provide: LOCALE_ID, useValue: 'pt-BR' },
        { provide: DateAdapter, useClass: MyDateAdapter },
        { provide: MD_DATE_FORMATS, useValue: MY_DATE_FORMATS },
        { provide: ErrorHandler, useClass: GlobalErrorHandler }
    ],
    bootstrap: [AppComponent]
})

export class AppModule {
    static injector: Injector;

    constructor(injector: Injector) {
        AppModule.injector = injector;
    }
}


// WEBPACK FOOTER //
// C:/Users/anderson.oshiro/Projetos/Azure/Ipcorp.PortalCobranca/Web/Ipcorp.PortalCobranca.Web/src/app/app.module.ts